import { Component, HostListener, ViewContainerRef, ElementRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Services } from './app.service';
import { SecurityManager } from './app.sec.component';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var moment: any;
@Component({
    providers: [Services, SecurityManager],
    templateUrl: './app.home.component.html'
})
export class HomeComponent implements OnInit {
    element = null;
    showNotificationModal = false;
    profile = {
        LastName: null,
        Mobile: null,
        Email: null,
        FirstName: null,
        Sessions: null,
    };
    constructor(private titleService: Title, private services: Services, private security: SecurityManager, private router: Router
        , private el: ElementRef) {
            //document.body.style.backgroundImage = 'url("assets/images/IntroBack.png")';
            document.body.style.backgroundImage = 'url("assets/images/s1.jpg")';
            document.body.style.backgroundRepeat = 'no-repeat';
            document.body.style.backgroundSize = 'cover';
        this.element = $(el.nativeElement);
    }


    getProfile = function () {
        this.services.getProfile().subscribe(
            (data) => { this.profile = data },
            (err) => { this.error = err });
    }
    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
    ngOnInit() {
        this.setTitle('پلنتو | برنامه ریزی مدرن بر فراز ابرها')
        if (this.security.checkToken()) {
            this.getProfile();
            this.getSettings();
        }


        this.element.on('click', function (e: any) {
            const target = $(e.target);

            if (!target.closest('.UserArea').length) {
                const minHeight = $('.DropDownMenu').css('min-height');
                if ($('.DropDownMenu').css('display') === 'block') {
                    $('.DropDownMenu').css('min-height', minHeight).slideToggle('fast', function () {
                        $(this).css('min-height', 0);
                    });
                }



                if (!target.closest('.ResponsiveSearchArea').length && !target.closest('.SearchBtn').length) {

                    if ($(window).width() < 600) {
                        $('.ResponsiveSearchArea').css('display', 'none')
                        // // tslint:disable-next-line:no-shadowed-variable
                        // const minHeight = $('.ResponsiveSearchArea').css('min-height');
                        // $('.ResponsiveSearchArea').css('min-height', 0).animate({
                        //     width: '0px'
                        // }, 100, function () {
                        //     $(this).css('min-height', minHeight);
                        // });
                    }

                }

            }
        });


    }

    onHelpClick() {
        this.showNotificationModal = true;
    }

    OpenDropDown() {
        const minHeight = $('.DropDownMenu').css('min-height');
        $('.DropDownMenu').css('min-height', 0).slideToggle('fast', function () {
            $(this).css('min-height', minHeight);
        });
    }
    ResponsiveSearchArea() {
        const minHeight = $('.ResponsiveSearchArea').css('min-height');
        $('.ResponsiveSearchArea').css('min-height', 0).animate({
            width: 'toggle'
        }, 500, function () {
            $(this).css('min-height', minHeight);
        });
    }

    getUrl() {
        return this.router.url;
    }
    setting() {
        this.router.navigateByUrl('home/profile');
    }
    getSettings = function () {
        this.services.getSettings().subscribe(
            (data) => {
                this.settings = data.Setting;


                this.settings.forEach((item, i) => {
                    if (item.Key === 'HelpMessage') {

                        this.helpNotificationMessage = item.Value1;



                    }
                });




            },
            (err) => { this.error = err });
    }


    logout = function () {
        this.services.logout().subscribe(
            (data) => {
                this.security.removeToken();
                this.router.navigateByUrl('login');


            },
            (err) => { this.error = err });
    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.home.component.ts